// components/DynamicHeader.tsx
import React from 'react';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { getBreadcrumbs } from '@/store/slices/breadcrumb';
import searchIcon from '@/assets/icons/search.svg';
import bellIcon from '@/assets/icons/bell.svg';
import dashboardIcon from '@/assets/icons/dashboard.svg';
import budgetsIcon from '@/assets/icons/budgets.svg';
import profileIcon from '@/assets/icons/profile.svg';
import commitmentIcon from '@/assets/icons/commitment.svg';
import invoiceIcon from '@/assets/icons/invoice.svg';
import ProfileDropdown from '@/components/molecules/ProfileDropdown';
import { PAGE } from '@/routes';

const DynamicHeader = () => {
  // Get breadcrumbs from Redux store
  const breadcrumbItems = useSelector(getBreadcrumbs);

  // Get the appropriate icon for the first breadcrumb item
  const getIconForPath = (path: string) => {
    if (path.startsWith(PAGE.DASHBOARD.path)) return dashboardIcon;
    if (path.startsWith(PAGE.BUDGETS.path)) return budgetsIcon;
    if (path.startsWith(PAGE.PROFILE.path)) return profileIcon;
    if (path.startsWith(PAGE.COMMITMENT.path)) return commitmentIcon;
    if (path.startsWith(PAGE.INVOICE.path)) return invoiceIcon;
    return null;
  };

  return (
    <header className="sticky w-full top-0 z-40 h-[64px] shadow-[0px_2px_4px_0px_#00000040] bg-white flex items-center justify-between px-7">
      {/* BREADCRUMBS */}
      <div className="flex items-center">
        <nav className="flex items-center" aria-label="Breadcrumb">
          <ol className="flex items-center flex-wrap">
            {breadcrumbItems.map((crumb, index) => {
              const isLast = index === breadcrumbItems.length - 1;
              const isFirst = index === 0;
              // Get icon from crumb or fallback to our function
              const icon = crumb.icon || (isFirst ? getIconForPath(crumb.path) : null);

              return (
                <li key={crumb.path} className="flex items-center">
                  {!isFirst && <span className="mx-2 text-gray-400">{'>'}</span>}

                  <div className="flex items-center">
                    {isFirst && icon && (
                      <img src={icon} alt={`${crumb.title.toLowerCase()} icon`} className="mr-2 h-5 w-5" />
                    )}

                    {isLast ? (
                      <span className="font-semibold text-gray">{crumb.title}</span>
                    ) : (
                      <Link to={crumb.path} className="text-gray-500 font-semibold hover:text-primary hover:underline">
                        {crumb.title}
                      </Link>
                    )}
                  </div>
                </li>
              );
            })}
          </ol>
        </nav>
      </div>

      <div className="flex items-center gap-9">
        {/* SEARCH */}
        <div className="relative flex bg-lightGray rounded-[16px] overflow-hidden h-[40px] w-[303px]">
          <img className="absolute top-[50%] translate-y-[-50%] left-[15px]" src={searchIcon} alt="search icon" />
          <input
            className="bg-transparent text-xs font-medium w-full placeholder:text-secondary placeholder:text-xs placeholder:font-medium pl-[43px] rounded-[16px]"
            type="text"
            placeholder="Search for Budgets, Accounts, etc..."
          />
        </div>

        {/* NOTIFICATIONS BELL */}
        <button>
          <img src={bellIcon} alt="bell icon" />
        </button>

        {/* PROFILE DROPDOWN */}
        <ProfileDropdown />
      </div>
    </header>
  );
};

export default DynamicHeader;
